import { AppEvent, trackEvent } from "app/util/tracking.util";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function TrackPageView() {
  const { pathname } = useLocation();

  useEffect(() => {
    trackEvent(AppEvent.PAGE_VIEW, {
      pathname,
    });
  }, [pathname]);

  return null;
}
